import "../kendo.csv.js";
import "./main.js";

(function($, kendo) {

function flattenColumns(columns) {
    let result = [];
    for (let i = 0; i < columns.length; i++) {
        if (columns[i].columns?.length) {
            result = result.concat(flattenColumns(columns[i].columns));
        } else {
            result.push(columns[i]);
        }
    }
    return result;
}

kendo.CSVMixin = {
    extend: function(proto) {
        proto.events.push("csvExport");
        proto.options.csv = $.extend(proto.options.csv, this.options);
        proto.saveAsCSV = this.saveAsCSV;
        proto.toCSVString = this.toCSVString;
        proto._renderCSVData = this._renderCSVData;
        proto._saveCSVData = this._saveCSVData;
        proto._saveCSVToFile = this._saveCSVToFile;
        proto._getCSVColumnsInfo = this._getCSVColumnsInfo;
    },
    options: {
        proxyURL: "",
        allPages: false,
        filterable: false,
        fileName: "Export.csv",
        delimiter: ",",
        lineSeparator: "\r\n",
        preventFormulaInjection: true,
        maxCellLength: 32767,
        maxRows: 1000000,
        maxColumns: 1000,
        includeUTF8BOM: false
    },
    _getCSVColumnsInfo: function() {
        const csv = this.options.csv || {};
        const columns = flattenColumns(this.columns || []);
        const visibleCols = columns.filter(function(c) {
            return !c.hidden && !(c.exportable === false || c.exportable?.csv === false);
        });

        return {
            keys: csv.keys || visibleCols.map(function(c) { return c.field || ""; }),
            names: csv.names || visibleCols.map(function(c) { return c.title || c.field || ""; })
        };
    },
    _saveCSVToFile: function(csvString, names) {
        const csv = this.options.csv || {};
        const blob = new Blob([csvString], {
            type: kendo.csv.getCSVMimeType({ names: names })
        });
        const reader = new FileReader();
        reader.onload = function() {
            kendo.saveAs({
                dataURI: reader.result,
                fileName: csv.fileName,
                proxyURL: csv.proxyURL,
                forceProxy: csv.forceProxy
            });
        };
        reader.readAsDataURL(blob);
    },
    _renderCSVData: function(data, includeHeaders) {
        const csv = this.options.csv || {};
        const csvColumns = this._getCSVColumnsInfo();
        const names = includeHeaders === false ? undefined : csvColumns.names;
        const csvData = typeof csv.data === "function" ? csv.data(data) : data;

        return {
            csvString: kendo.csv.toCSV({
                data: csvData,
                keys: csvColumns.keys,
                names: names,
                delimiter: csv.delimiter,
                lineSeparator: csv.lineSeparator,
                preventFormulaInjection: csv.preventFormulaInjection,
                maxCellLength: csv.maxCellLength,
                maxRows: csv.maxRows,
                maxColumns: csv.maxColumns,
                includeUTF8BOM: csv.includeUTF8BOM,
                groupHeaderFormatter: csv.groupHeaderFormatter,
                groupValueFormatter: csv.groupValueFormatter
            }),
            names: names || []
        };
    },
    _saveCSVData: function(data, includeHeaders) {
        const exportData = this._renderCSVData(data, includeHeaders);

        this._saveCSVToFile(exportData.csvString, exportData.names);

        return exportData.csvString;
    },
    saveAsCSV: function() {
        const that = this;
        const csv = this.options.csv || {};

        const exporter = new kendo.CSVExporter({
            dataSource: this.dataSource,
            allPages: csv.allPages,
            filterable: csv.filterable
        });

        return exporter.export().then(function(csvData) {
            return that._saveCSVData(csvData);
        });
    },
    toCSVString: function() {
        const csv = this.options.csv || {};
        const deferred = $.Deferred();
        const that = this;

        const exporter = new kendo.CSVExporter({
            dataSource: this.dataSource,
            allPages: csv.allPages,
            filterable: csv.filterable
        });

        exporter.export().then(function(csvData) {
            deferred.resolve(that._renderCSVData(csvData).csvString);
        });

        return deferred.promise();
    }
};

})(kendo.jQuery, kendo);
